export class CartError extends Error {
    public readonly data?: unknown;

    public constructor(name: string, message?: string | null, data?: unknown) {
        super(message ?? name);
        this.name = name;
        this.data = data;
    }
}
